import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { Dashboard } from './Dashboard';
import { CallLogs } from './CallLogs';
import { AgentsList } from './AgentsList';
import { AdminAgentsList } from './AdminAgentsList';
import { AdminCallLogs } from './AdminCallLogs';
import { AdminUsersList } from './AdminUsersList';
import { Account } from './Account';
import { Billing } from './Billing';
import { Menu } from 'lucide-react';
import type { UserRole } from '../lib/auth';

interface AdminDashboardProps {
  userEmail: string;
  userRole: UserRole;
}

export function AdminDashboard({ userEmail, userRole }: AdminDashboardProps) {
  const [activeView, setActiveView] = React.useState('dashboard');
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const renderView = () => {
    switch (activeView) {
      case 'dashboard':
        return <Dashboard userEmail={userEmail} />;
      case 'call-logs':
        return userRole === 'admin' ? <AdminCallLogs userEmail={userEmail} /> : <CallLogs userEmail={userEmail} />;
      case 'agents':
        return userRole === 'admin' ? <AdminAgentsList /> : <AgentsList userEmail={userEmail} />;
      case 'users':
        return userRole === 'admin' ? <AdminUsersList /> : null;
      case 'analytics':
        return <div className="p-8">
          <h2 className="text-2xl font-bold text-white mb-4">Analytics</h2>
          <p className="text-zinc-400">Analytics features coming soon...</p>
        </div>;
      case 'settings':
        return <div className="p-8">
          <h2 className="text-2xl font-bold text-white mb-4">Settings</h2>
          <p className="text-zinc-400">Settings features coming soon...</p>
        </div>;
      case 'billing':
        return <Billing />;
      case 'account':
        return <Account userEmail={userEmail} />;
      default:
        return <Dashboard userEmail={userEmail} />;
    }
  };

  return (
    <div className="flex">
      <Sidebar
        activeView={activeView}
        onViewChange={setActiveView}
        userRole={userRole}
        isOpen={isSidebarOpen}
      />
      <div className={`flex-1 transition-all duration-300 ${isSidebarOpen ? 'ml-64' : 'ml-0'}`}>
        <div className="sticky top-0 z-40 bg-black/80 backdrop-blur-sm border-b border-zinc-800 px-4 h-16 flex items-center">
          <button
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            className="p-2 hover:bg-zinc-800 rounded-lg transition-colors"
          >
            <Menu className="w-6 h-6 text-zinc-400" />
          </button>
        </div>
        {renderView()}
      </div>
    </div>
  );
}